import React, { useState } from 'react';
import { Play, Eye, TrendingUp } from 'lucide-react';
import { viralContent } from '../mock';

const ViralContent = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section id="content" className="bg-[#0a0a0a] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#ff6b35]/10 border border-[#ff6b35]/30 rounded-full">
            <span className="text-[#ff6b35] font-semibold text-sm tracking-wider uppercase">
              Viral Content
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Content That Performs
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            High-energy workouts, transformations, and fitness tips that drive millions of views
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {viralContent.map((content) => (
            <div
              key={content.id}
              className="relative group cursor-pointer overflow-hidden rounded-lg bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-[#00ff41] transition-all duration-300"
              onMouseEnter={() => setHoveredId(content.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={content.image}
                  alt={content.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
              </div>

              {/* Play icon overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className={`w-16 h-16 rounded-full bg-[#00ff41]/90 flex items-center justify-center transition-all duration-300 ${
                    hoveredId === content.id ? 'scale-110' : 'scale-100'
                  }`}
                >
                  <Play className="text-black fill-black ml-1" size={28} />
                </div>
              </div>

              {/* Content info */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="mb-2">
                  <span className="inline-block px-3 py-1 bg-[#00ff41] text-black text-xs font-bold rounded-full">
                    {content.type}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{content.title}</h3>
                <div className="flex items-center gap-4 text-sm">
                  <div className="flex items-center gap-1 text-gray-300">
                    <Eye size={16} />
                    <span className="font-semibold">{content.views}</span>
                  </div>
                  <div className="flex items-center gap-1 text-[#00ff41]">
                    <TrendingUp size={16} />
                    <span className="font-semibold">{content.engagement}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ViralContent;
